import React from 'react';
import appState from '../../state/AppStateContainer';
import BtButton from '../bt-button/bt-button';
import { ServiceDownload } from '../../services/service-download';
import ExcelIcon from '../../assets/images/excel.png';
import Tabs from '../../components/shared/Tabs';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import { TabNames } from './supplier-database';
import { useTranslation } from 'react-i18next';

const TableTopActions = (props) => {
  const { onAddArea, onAddSupplier, isReadOnlyUser, selectedTab, onTabChange, numberOfRecommendedSuppliers, selectMode, inboxCount, onShowSupplierApplicationInfo, isFeaturedSupplier, selectedTabName, monitoringView, onSelectMonitoring } = props;
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'tableTopActions' });
  const tabs = [t('tabs.register', 'Register')];
  if (!selectMode) {
    tabs.push(<span style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>{t('tabs.applications', 'Ansökningar')} <NotificationCounter style={{ backgroundColor: 'var(--gray-200)', color: 'var(--gray-800)' }} counter={inboxCount} /></span>);

    if (isFeaturedSupplier) {
      tabs.push(('tabs.featuredSupplier', 'Utvald leverantör'));
    }

    if (appState.isSuperAdminOrg()) {
      tabs.push(('tabs.adApplications', 'Annonsansökningar'));
    }
  }
  if (selectMode && numberOfRecommendedSuppliers > 0) {
    tabs.push(<span style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>{t('tabs.recommendedSuppliers', 'Rekommenderade leverantörer')} <NotificationCounter style={{ backgroundColor: 'var(--gray-200)', color: 'var(--gray-800)' }} counter={numberOfRecommendedSuppliers} /></span>);
  }

  // Nekade ansökningar is register tab 2 but shares the Ansökningar tab, behind its status filter.
  const barIndexOf = tab => (!selectMode && tab >= 2 ? tab - 1 : tab);
  const tabOfBarIndex = index => (!selectMode && index >= 2 ? index + 1 : index);
  const onApplicationsTab = !selectMode && barIndexOf(selectedTab) === 1;

  const org = appState.getOrgFromUrl();
  const showMonitoringTabs = monitoringView || (onSelectMonitoring && !appState.superAdminOrgAndUser() && (org?.hasSyna || org?.hasCreditsafe));
  const monitoringTabs = [
    { view: 'suppliers', subPath: '/monitoring', label: t('tabs.monitoring', 'Bevakning') },
    { view: 'events', subPath: '/monitoring/events', label: t('tabs.monitoringEvents', 'Bevakningshändelser') },
  ];
  const firstMonitoringTabIndex = tabs.length;
  if (showMonitoringTabs) {
    tabs.push(...monitoringTabs.map(tab => tab.label));
  }
  const selectedMonitoringTab = monitoringTabs.findIndex(tab => tab.view === monitoringView);
  const selected = selectedMonitoringTab >= 0 ? firstMonitoringTabIndex + selectedMonitoringTab : barIndexOf(selectedTab);
  const onChange = index => {
    const monitoringTab = showMonitoringTabs && monitoringTabs[index - firstMonitoringTabIndex];
    if (monitoringTab) {
      onSelectMonitoring(monitoringTab.subPath);
    } else {
      onTabChange(tabOfBarIndex(index));
    }
  };

  return (
    <div className="sp-top-actions">
      <div className="tab-container">
        <Tabs tabs={tabs} selected={selected} onChange={onChange} style={{ marginBottom: '20px' }} />
        {!isReadOnlyUser && !monitoringView && (
          <div className="sp-btn-group">
            {appState.isAdminRole() && selectedTabName !== TabNames.AD_APPLICATIONS && (
              <BtButton
                class="white"
                onClick={async () => { await ServiceDownload.downloadSupplierExcelFile(); }}
                leftIcon={<img className="excel-icon--style" src={ExcelIcon} width="25px" height="25px" />}
                style={{ border: '1px solid var(--gray-300)' }}
              >
                {t('button.exportShort', 'Export')}
              </BtButton>
            )}

            {onAddArea && selectedTabName !== TabNames.AD_APPLICATIONS && appState.isAdminRole() && (
              <BtButton class='white' onClick={onAddArea}>
                <span>{t('button.manageArea', 'Hantera kategorier')}</span>
              </BtButton>
            )}

            {onAddSupplier && !onApplicationsTab && selectedTabName !== TabNames.AD_APPLICATIONS && (
              <BtButton onClick={onAddSupplier}>
                <span>{t('button.addSupplier', 'Lägg till leverantör')}</span>
              </BtButton>
            )}

            {onShowSupplierApplicationInfo && onApplicationsTab && (
              <BtButton class='white' onClick={onShowSupplierApplicationInfo}>{t('button.applicationInfo', 'Ansökningsformulär')}</BtButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableTopActions;
